import { hotels_sections } from "./hotels-sections";
import {
  liveflight_sections,
  liveflight_sections_visitor,
} from "./liveflight-sections";
import { build_default_content, VALUE_PROPOSITION_BLOCK } from "./utilities";
import { vivamod_sections } from "./vivamod-sections";

const content = {
  hotels: hotels_sections,
  vivamod: vivamod_sections,
  liveflight: liveflight_sections,
};

const not_authenticated_content = {
  liveflight: liveflight_sections_visitor,
};

/**
 * Restituisce il content builder appropriato per un determinato brand
 * Gestisce la logica di autenticazione per brand che hanno contenuti differenziati
 * per utenti autenticati e visitatori (es. liveflight)
 *
 * @param {string} brand - Identificativo del brand (es. "hotels", "vivamod", "liveflight")
 * @param {boolean} authenticated - Indica se l'utente è autenticato
 * @returns {Function} Funzione builder che accetta config e restituisce Array<Object> di blocchi sezione
 *
 * @example
 * // Ottenere il builder per un brand autenticato
 * const builder = get_brand_content_builder("liveflight", true);
 * const sections = builder(config);
 *
 * @example
 * // Per brand non riconosciuto, restituisce build_default_content
 * const builder = get_brand_content_builder("unknown", false);
 */
export const get_brand_content_builder = (brand, authenticated) => {
  const brand_key = (brand || "").toLowerCase();
  const brand_content = content[brand_key];
  if (!authenticated && not_authenticated_content[brand_key]) {
    return not_authenticated_content[brand_key];
  }
  return brand_content || build_default_content;
};

/**
 * Contenuti statici del brand come blocchi CMS (`{ component, props }`), con
 * l'alternanza destra/sinistra che il blocco riceve in base alla posizione.
 *
 * @param {string} brand - Identificativo del brand
 * @param {boolean} authenticated - Indica se l'utente è autenticato
 * @param {Object} config - Configurazione del sito
 * @returns {Array<Object>} Blocchi
 */
export const get_brand_blocks = (brand, authenticated, config) =>
  get_brand_content_builder(brand, authenticated)(config).map(
    ({ type, props }, index) => {
      let position = { direction: index % 2 === 0 ? "right" : "left" };
      if (type === VALUE_PROPOSITION_BLOCK) {
        position = { invert: index % 2 === 0 };
      }
      return { component: type, props: { ...position, ...props } };
    },
  );

export * from "./utilities";
